import { Toast } from 'bootstrap'
import { i18n } from '../plugins/i18n'

type ToastVariant = 'danger' | 'warning' | 'info' | 'success'

interface ToastOptions {
  title?: string
  noTitle?: boolean
  message: string
  variant?: ToastVariant
  delay?: number
}

const defaultTitle = i18n.global.t('error')

export function showToast({
  title,
  message,
  variant = 'danger',
  delay = 10000,
  noTitle = false,
}: ToastOptions): void {
  const resolvedTitle = title ?? defaultTitle
  const container = document.getElementById('app-toast-container')
  if (!container) return

  const el = document.createElement('div')

  let processedTitle = ''
  if (!noTitle) {
    processedTitle = `<strong class="me-2" v-if="">${resolvedTitle}</strong>`
  }

  el.className = `toast align-items-center text-bg-${variant} border-0`
  el.role = 'alert'
  el.ariaLive = 'assertive'
  el.ariaAtomic = 'true'

  el.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">
        ${processedTitle}
        ${message}
      </div>
      <button
        type="button"
        class="btn-close btn-close-white me-2 m-auto"
        data-bs-dismiss="toast"
        aria-label="Close"
      ></button>
    </div>
  `

  container.appendChild(el)

  const toastDelay = variant === 'success' ? 1500 : delay
  const toast = new Toast(el, { delay: toastDelay })
  toast.show()

  el.addEventListener('hidden.bs.toast', () => {
    el.remove()
  })
}
